/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2022 (original work) Open Assessment Technologies SA ;
 */
import { withUnit } from '../../../util/size.js';

/**
 * Properties mapper for the Figure static element
 */
export default {
    /**
     * Map QTI custom properties into attributes
     * @param {Object} properties
     * @param {Object} element
     * @returns {Object} mapped properties
     */
    mapProperties(properties, element) {
        if (properties.blockTree) {
            const elementsImage = Object.values(element.body.elements).find(node => node && node.qtiClass === 'img');
            const itemBlocksImage = properties.blockTree.find(
                node => node.type === 'element' && node.content === (elementsImage && elementsImage.serial)
            );

            // If there is a nested image which has a `width`, move this `width` up to the figure.
            // Image's `height` can stay.
            // Note: figure with multiple nested images is not yet supported in terms of styling.
            if (itemBlocksImage && elementsImage && elementsImage.attributes) {
                if (elementsImage.attributes.width) {
                    properties.imageElementWidth = withUnit(elementsImage.attributes.width); //should be set as 'style="width"' of <figure>
                    properties.imageElementHeight = withUnit(elementsImage.attributes.height);
                    itemBlocksImage.props.attributes.width = '100%';
                } else {
                    properties.class = `${properties.class || ''} auto-width`;
                }
            }
        }
        return properties;
    }
};
